import axios from "axios";
import React, { useState, useEffect } from "react";
import Select from "react-select";
import {
  Button,
  ErrorMsg,
  RadioSelector,
} from "@onegovbugs/onegov-react-components";
import styles from "./FocusOfWork.module.scss";
import {
  isSelected,
  validate,
  objExistInArray,
  scrollToError,
  isNumeric
} from "../../../utils/Validation";
import { useSelector, useDispatch } from "react-redux";
import AsyncSelect from "react-select/async";
import {
  getSampleUnits,
  getTargetParts,
  getSpeciesTypes,
  searchSpecies,
  clearSpeciesSearch
} from "redux/actions/floraFauna/focusOfWorkData";
import { withRouter } from "react-router-dom";
import { storeSpeciesData } from "../../../redux/actions";
import { RedirectIfCaptchaNotSelected } from "../../../utils/Redirect";
import ScrollToTop from "../../../utils/ScrollToTop";
import {removeLeadingZeros} from "../../../utils/FormatHelper";

const FocusOfWorkForm = (props) => {
  RedirectIfCaptchaNotSelected(props);
  ScrollToTop();

  const dispatch = useDispatch();

  let index = props.match.params.id;

  const oidc = useSelector((state) => state.oidc);
  const token = oidc.user && oidc.user.access_token;
  const focusOfWorkDetail = useSelector((state) => state.focusOfWorkDetail);
  const [focusOfWorkList, setFocusOfWorkList] = useState(
    focusOfWorkDetail && focusOfWorkDetail.focusOfWorkList
      ? focusOfWorkDetail.focusOfWorkList.map((on) => ({ ...on }))
      : []
  );
  const editFocusOfWork =
    index && focusOfWorkList && focusOfWorkList.length > 0
      ? focusOfWorkList[index]
      : undefined;

  const [speciesType, setSpeciesType] = useState(
    editFocusOfWork ? editFocusOfWork.speciesType : null
  );
  const [targetPart, setTargetPart] = useState(
    editFocusOfWork ? editFocusOfWork.targetPart : ""
  );
  const [commonName, setCommonName] = useState(
    editFocusOfWork ? editFocusOfWork.commonName : ""
  );
  const [sampleUnit, setSampleUnit] = useState(
    editFocusOfWork ? editFocusOfWork.sampleUnit : ""
  );
  const [targetPartNumber, settargetPartNumber] = useState(
    editFocusOfWork ? editFocusOfWork.targetPartNumber : ""
  );
  const [speciesSearch, setSpeciesSearch] = useState(
    editFocusOfWork ? editFocusOfWork.speciesSearch : ""
  );
  const [speciesSearchResult, setSpeciesSearchResult] = useState(null);

  // Get RefData
  useEffect(() => {
    dispatch(getSpeciesTypes());
  }, [dispatch]);
  useEffect(() => {
    dispatch(getTargetParts());
  }, [dispatch]);
  useEffect(() => {
    dispatch(getSampleUnits());
  }, [dispatch]);

  // toggle dropdowns
  const [showCommonName, setCommonNameView] = useState(false);
  const [showSpeciesSearch, setSpeciesSearchView] = useState(false);

  useEffect(() => {
    const selectedSpecies = speciesType ? speciesType.value : null;
    dispatch(clearSpeciesSearch());
   
    switch (speciesType) {
      case "FA":
      case "FL":
        setSpeciesSearchView(true);
        setCommonNameView(false);
        break;
      case "Other":
      case "TEC":
        setSpeciesSearch("");
        setCommonNameView(true);
        setSpeciesSearchView(false);
        break;
    }
  }, [speciesType]);

  // Dropdown options
  const speciesTypeOptions =
    focusOfWorkDetail && focusOfWorkDetail.speciesTypes
      ? focusOfWorkDetail.speciesTypes
      : [];
  const sampleUnitOptions =
    focusOfWorkDetail && focusOfWorkDetail.sampleUnits
      ? focusOfWorkDetail.sampleUnits
      : [];
  const targetPartOptions =
    focusOfWorkDetail && focusOfWorkDetail.targetParts
      ? focusOfWorkDetail.targetParts
      : [];

  // Power search
  // const searchSpeciesOptions = (keyWord, callback) => {
  //   let searchType = "CommonName";

  //   if (speciesType == "FA" || speciesType == "FL") {
  //     searchType = "Species";
  //   }

  //   dispatch(searchSpecies(keyWord, speciesType, searchType));
  //   const response =
  //     focusOfWorkDetail && focusOfWorkDetail.searchSpecies
  //       ? focusOfWorkDetail.searchSpecies
  //       : [];

  //   const speciesList = response.map((item) => {
  //     if (searchType == "CommonName") {
  //       return { value: item.row_Id, label: item.commonName };
  //     }
  //     return { value: item.row_Id, label: item.label };
  //   });
  //   callback(speciesList);
  // };
  const searchSpeciesOptions = (keyWord) => {
    let searchType = "Species";
        
    if (keyWord && keyWord.length > 2) {
      return axios
        .get(
          `${process.env.REACT_APP_BASE_URL}/nativespeciesapi/V1/florafauna/searchSpecies?keyword=${keyWord}&speciesType=${speciesType}&searchType=${searchType}`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then(r => r.data.map(d => {
          setSpeciesSearchResult(r.data);
          return {
          value: d.row_Id,
          label: d.label}
        }
      ));
        // .then(r => {
        //   if (searchType == "CommonName") {
        //     r.data.map(d => ({
        //       value: d.row_Id,
        //       label: d.commonName,
        //     }));
        //   } else
        //     r.data.map(d => ({
        //       value: d.row_Id,
        //       label: d.label,
        //     }));
        // });
      // .then((r) => {
      //     r.data.map(d => {
      //       if(searchType == "CommonName"){
      //         return { value: d.row_Id, label: d.commonName };
      //       }
      //       else{
      //         return { value: d.row_Id, label: d.label };
      //       }
      //     })
      // });
    } else {
      return new Promise((resolve) => resolve([]));
    } 
  };

  const searchCommonName = (keyWord) => {
    let searchType = "CommonName";    
    
    if (keyWord && keyWord.length > 2) {
      return axios
        .get(
          `${process.env.REACT_APP_BASE_URL}/nativespeciesapi/V1/florafauna/searchSpecies?keyword=${keyWord}&speciesType=${speciesType}&searchType=${searchType}`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then(r => r.data.map(d => ({
          value: d.row_Id,
          label: d.commonName
        })
      ));       
    } else {
      return new Promise((resolve) => resolve([]));
    } 
  };

  // set common name
  const setCommonNameValue = (value) => {
    const commonName = speciesSearchResult
      .filter((x) => x.row_Id == value)
      .map((item) => {
        if (item.commonName === undefined){
          return null;
        }
        return { value: item.commonName, label: item.commonName };
      });
    setCommonName(commonName[0]);
  };

  //validaitons
  const valiDatePowerSearch = () => {
    if (speciesType) {
      if (
        (speciesType == "FA" || speciesType == "FL") &&
        speciesSearch.length == 0
      ) {
        return false;
      }
      if (
        (speciesType == "Other" || speciesType == "TEC") &&
        commonName.length == 0
      ) {
        return false;
      }
    }

    return true;
  };

  const [showErrors, setShowErrors] = useState(false);
  const [errors, setErrors] = useState({
    speciesType: false,
    speciesSearch: false,
    commonName: false,
    focusOfWorkAlreadyExists: false,
  });

  const validators = [
    {
      fieldName: "speciesType",
      fieldValue: speciesType,
      isValid: isSelected,
    },
    {
      fieldName: "speciesSearch",
      fieldValue: speciesSearch,
      isValid: valiDatePowerSearch,
    },
    {
      fieldName: "commonName",
      fieldValue: commonName,
      isValid: valiDatePowerSearch,
    },
    {
      fieldName: "targetPartNumber",
      fieldValue: targetPartNumber,
      isValid:  isNumeric
    },
    {
      fieldName: "focusOfWorkAlreadyExists",
      fieldValue: focusOfWorkList,
      isValid: (v) => {
        if ((v && v.length === 0) || index !== undefined) return true;
        const newLocation = {
          speciesType: speciesType ? speciesType : "",
          targetPart: targetPart ? targetPart : "",
          sampleUnit: sampleUnit ? sampleUnit : "",
          commonName: commonName ? commonName : "",
          speciesSearch: speciesSearch ? speciesSearch : "",
          targetPartNumber: targetPartNumber ? removeLeadingZeros(targetPartNumber) : "",
        };
        return objExistInArray(v, newLocation);
      },
    },
  ];

  useEffect(() => {
    validate(validators, setErrors);
  }, [speciesType, speciesSearch, commonName, targetPartNumber]);

  const storeData = () => {
    const focusOfRecord = {
      focusOfWorkList: [
        ...focusOfWorkList,
        {
          speciesType: speciesType ? speciesType : "",
          targetPart: targetPart ? targetPart : "",
          sampleUnit: sampleUnit ? sampleUnit : "",
          commonName: commonName ? commonName : "",
          speciesSearch: speciesSearch ? speciesSearch : "",
          targetPartNumber: targetPartNumber ? removeLeadingZeros(targetPartNumber) : "",
        },
      ],
    };
    dispatch(storeSpeciesData(focusOfRecord));
  };

  const editData = (updatedFocusOfWork) => {
    const qualificationRecord = {
      focusOfWorkList: updatedFocusOfWork,
    };

    dispatch(storeSpeciesData(qualificationRecord));
  };

  const saveFocusOfWorkData = () => {
    if (focusOfWorkList && focusOfWorkList.length > 0) {
      if (index) {
        let updatedFocusOfWork = [...focusOfWorkList];

        updatedFocusOfWork[index] = {
          speciesType: speciesType ? speciesType : "",
          targetPart: targetPart ? targetPart : "",
          sampleUnit: sampleUnit ? sampleUnit : "",
          commonName: commonName ? commonName : "",
          speciesSearch: speciesSearch ? speciesSearch : "",
          targetPartNumber: targetPartNumber ? removeLeadingZeros(targetPartNumber) : "",
        };
        editData(updatedFocusOfWork);
      } else {
        storeData();
      }
    } else {
      storeData();
    }
  };

  return (
    <div className={styles.mainCont}>
      <div className={"row"}>
        <div className={`col-12 col-sm-6`}>
          <label htmlFor="speciesType">Species Type</label>
          <RadioSelector
            className = {styles.topMargin24}
            id={"radioSpeciesType"}
            horizontal
            options={speciesTypeOptions}
            onSelectionChange={(selectedValue) => {
              setSpeciesType(selectedValue);
              setSpeciesSearch("");
              setCommonName("");
            }}
            initialValue={speciesType}
          />
          {errors.speciesType && showErrors ? (
            <ErrorMsg
              className={"ErrorMsg_error"}
              type={"error"}
              description={"Species Type is required."}
            />
          ) : null}
        </div>
      </div>
      {showSpeciesSearch && (
        <div className={styles.asyncSelect}>
        <div className={"row"}>
          <div className={"col-12 col-sm-6"}>
            <label htmlFor="searchSpecies">
              Family / Genus / Species / Subspecies
            </label>
            <AsyncSelect
              id="inputSpecies"
              value={speciesSearch}
              placeholder={"Type to search"}
              components={{
                DropdownIndicator: () => null,
                IndicatorSeparator: () => null
              }}
              isClearable
              loadOptions = {searchSpeciesOptions}
              // loadOptions={(keyWord, callback) => {
              //   if (keyWord.length > 2) {
              //     searchSpeciesOptions(keyWord, callback);
              //   } else {
              //     callback([]);
              //   }
              // }}
              className={styles.AsyncSelect}
              onChange={(event) => {             
                if (event !== null ){
                  setSpeciesSearch(event);
                  setCommonNameValue(event.value);
                }
                else{
                  setSpeciesSearch("");
                  setCommonNameValue("");
                }               
              }}            
            />
            {errors.speciesSearch && showErrors ? (
              <ErrorMsg
                className={"ErrorMsg_error"}
                type={"error"}
                description={
                  "Family / Genus / Species / Subspecies is required when species type is FA or FL."
                }
              />
            ) : null}
          </div>
          {commonName && (
            <div className={"col-12"}>
              <div className={`${styles.searcResult}`}>
                <div className={"row"}>
                  <div className={`col-3 ${styles.divContentLabel}`}>
                    <label>Common Name</label>
                  </div>
                  <div className={`col-7 ${styles.divContentValue}`}>
                    {commonName.value}
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
        </div>
      )}
      {showCommonName && (
        <div className={styles.asyncSelect}>
        <div className={"row"}>
          <div className={"col-12 col-sm-6"}>
            <label htmlFor="commonName">Common Name</label>
            <AsyncSelect
              id="inputCommonName"
              value={commonName}
              placeholder={"Type to search"}
              components={{
                DropdownIndicator: () => null,
                IndicatorSeparator: () => null
              }}
              isClearable
              // loadOptions={(keyWord, callback) => {
              //   if (keyWord.length > 2) {
              //     searchSpeciesOptions(keyWord, callback);
              //   } else {
              //     callback([]);
              //   }
              // }}              
              //onChange={setCommonName}
              className={styles.AsyncSelect}
              loadOptions={searchCommonName}
              onChange={(event) => {             
                if (event !== null ){
                  setCommonName(event);
                }
                else{
                  setCommonName("");
                }               
              }} 
            />
            {errors.commonName && showErrors ? (
              <ErrorMsg
                className={"ErrorMsg_error"}
                type={"error"}
                description={
                  "Common name is required when species type is TEC or Other."
                }
              />
            ) : null}
          </div>
        </div>
        </div>
      )}
      <hr className={styles.hrLine} />

      <div className={"row"}>
        <div className={"col-12 col-sm-6"}>
          <label htmlFor="targetPart">Target Part (Optional)</label>
          <Select
            id="inputtargetPart"
            value={targetPart}
            onChange={setTargetPart}
            className={styles.select}
            options={targetPartOptions}
            isClearable
          />
        </div>
        <div className={"col-12 col-sm-6"}>
          <label htmlFor="dob">Sample Unit (Optional)</label>
          <Select
            id="inputSampleUnits"
            className={styles.select}
            options={sampleUnitOptions}
            value={sampleUnit}
            onChange={setSampleUnit}
             isClearable
          />
        </div>
      </div>
      <div className={"row"}>
        <div className={`col-12 col-sm-6`}>
          <label htmlFor="targetPart">No Of Target Parts (Optional)</label>
          <input
            id="inputtargetPart"
            className={styles.inputBox}
            value={targetPartNumber}
            onChange={(event) => {
              settargetPartNumber(event.target.value);
            }}
          />
        </div>
        {showErrors && errors.targetPartNumber ?
              (
                <div className={`col-12`}>
                  <ErrorMsg
                    type={"error"}
                    description={"Invalid value for Number of Target Parts."}
                  />
                </div>
              ) : null

        }
      </div>
      {errors.focusOfWorkAlreadyExists && showErrors ? (
        <ErrorMsg
          className={"ErrorMsg_error"}
          type={"error"}
          description={"Location detail already exists."}
        />
      ) : null}
      <div className={"row " + styles.buttonCont}>
        <div className={"col-12"}>
          <Button
            onClick={() => {
              if (validate(validators, setErrors)) {
                saveFocusOfWorkData();
                props.history.push(`/flora-fauna/focusofwork`);
              } else {
                setShowErrors(true);
                scrollToError();
              }
            }}
          >
            Save
          </Button>
          <Button
            secondary
            onClick={() => {
              setShowErrors(false);
              props.history.push(`/flora-fauna/focusofwork`);
            }}
          >
            Cancel
          </Button>
        </div>
      </div>
    </div>
  );
};

export default withRouter((props) => <FocusOfWorkForm {...props} />);
